import axios from 'axios';
import useConfigStore from '../store/config';

/**
 * Cookie-authed (`ory_kratos_session`) AllAuth endpoints. These must NOT go
 * through the bearer-authed Mobilix client — the cookie is the credential.
 */

export interface AllAuthUserProfile {
  id: string;
  email: string;
  /** AllAuth tenant short code, e.g. 'lts'. */
  tenant_id: string;
  /** Tenant display name. */
  tenant: string;
  organization_id?: string;
  organization?: string;
  role_id: string;
  role: string;
  application_id: string;
  application: string;
  active: boolean;
}

export const fetchProfiles = async (): Promise<AllAuthUserProfile[]> => {
  const { allauth } = useConfigStore.getState();
  const response = await axios.get<AllAuthUserProfile[]>(
    `${allauth.apiBaseUrl}/profiles`,
    {
      params: { application_uri: allauth.applicationUri },
      withCredentials: true,
    },
  );
  return response.data;
};

export const mintToken = async (userProfileId: string): Promise<string> => {
  const { allauth } = useConfigStore.getState();
  const response = await axios.get<{ access_token: string }>(
    `${allauth.apiBaseUrl}/profiles/token`,
    {
      params: { user_profile_id: userProfileId, audience: allauth.audience },
      withCredentials: true,
    },
  );
  return response.data.access_token;
};
